import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPKnowledge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 18,
	viewBox: "0 0 22 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.26 1.01382V14.3197L3.24 12.9041V1.11999C3.24 0.412231 3.81375 -0.118587 4.48875 0.0229646L10.26 1.01382ZM3.00375 14.2489L10.8 15.8767L18.5625 14.2489C19.0688 14.1427 19.44 13.6473 19.44 13.1165V0.907661L20.2838 0.730722C20.9587 0.58917 21.6 1.11999 21.6 1.82775V14.8151C21.6 15.3813 21.2288 15.8413 20.7225 15.9475L10.8 18L0.84375 15.9475C0.3375 15.8413 0 15.3459 0 14.8151V1.82775C0 1.11999 0.6075 0.58917 1.2825 0.730722L2.16 0.907661V13.1165C2.16 13.6827 2.4975 14.1427 3.00375 14.2489ZM11.34 14.3197V1.01382L17.0775 0.0229646C17.7525 -0.118587 18.36 0.412231 18.36 1.11999V12.9041L11.34 14.3197Z",
		fill: "#32C8DC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.00375 14.2489L10.8 15.8767L18.5625 14.2489C19.0688 14.1427 19.44 13.6473 19.44 13.1165V0.907668L20.2837 0.730729C20.9587 0.589177 21.6 1.11999 21.6 1.82775V14.8151C21.6 15.3813 21.2288 15.8413 20.7225 15.9475L10.8 18L0.84375 15.9475C0.3375 15.8413 0 15.3459 0 14.8151V1.82775C0 1.11999 0.6075 0.589177 1.2825 0.730729L2.16 0.907668V13.1165C2.16 13.6827 2.4975 14.1427 3.00375 14.2489Z",
		fill: "#005AFF"
	})]
});
export default SvgPKnowledge;
